/* eslint-disable no-console */
/*
 * Convert a style.json file exported from Mapbox Studio into a JS file usable by vms-map
 */
import * as R from 'ramda';
import { Functional as F } from '@wayfinder/vms-base';

const keyToLayerStyle = key => {
    switch (key) {
        case 'background-color':
            return 'paint';
        case 'background-opacity':
            return 'paint';
        case 'background-pattern':
            return 'paint';
        case 'circle-blur':
            return 'paint';
        case 'circle-color':
            return 'paint';
        case 'circle-opacity':
            return 'paint';
        case 'circle-pitch-alignment':
            return 'paint';
        case 'circle-pitch-scale':
            return 'paint';
        case 'circle-radius':
            return 'paint';
        case 'circle-sort-key':
            return 'layout';
        case 'circle-stroke-color':
            return 'paint';
        case 'circle-stroke-opacity':
            return 'paint';
        case 'circle-stroke-width':
            return 'paint';
        case 'circle-translate':
            return 'paint';
        case 'circle-translate-anchor':
            return 'paint';
        case 'fill-antialias':
            return 'paint';
        case 'fill-color':
            return 'paint';
        case 'fill-extrusion-base':
            return 'paint';
        case 'fill-extrusion-color':
            return 'paint';
        case 'fill-extrusion-height':
            return 'paint';
        case 'fill-extrusion-opacity':
            return 'paint';
        case 'fill-extrusion-pattern':
            return 'paint';
        case 'fill-extrusion-translate':
            return 'paint';
        case 'fill-extrusion-translate-anchor':
            return 'paint';
        case 'fill-extrusion-vertical-gradient':
            return 'paint';
        case 'fill-opacity':
            return 'paint';
        case 'fill-outline-color':
            return 'paint';
        case 'fill-pattern':
            return 'paint';
        case 'fill-sort-key':
            return 'layout';
        case 'fill-translate':
            return 'paint';
        case 'fill-translate-anchor':
            return 'paint';
        case 'heatmap-color':
            return 'paint';
        case 'heatmap-intensity':
            return 'paint';
        case 'heatmap-opacity':
            return 'paint';
        case 'heatmap-radius':
            return 'paint';
        case 'heatmap-weight':
            return 'paint';
        case 'hillshade-accent-color':
            return 'paint';
        case 'hillshade-exaggeration':
            return 'paint';
        case 'hillshade-highlight-color':
            return 'paint';
        case 'hillshade-illumination-anchor':
            return 'paint';
        case 'hillshade-illumination-direction':
            return 'paint';
        case 'hillshade-shadow-color':
            return 'paint';
        case 'icon-allow-overlap':
            return 'layout';
        case 'icon-anchor':
            return 'layout';
        case 'icon-color':
            return 'paint';
        case 'icon-halo-blur':
            return 'paint';
        case 'icon-halo-color':
            return 'paint';
        case 'icon-halo-width':
            return 'paint';
        case 'icon-ignore-placement':
            return 'layout';
        case 'icon-image':
            return 'layout';
        case 'icon-keep-upright':
            return 'layout';
        case 'icon-offset':
            return 'layout';
        case 'icon-opacity':
            return 'paint';
        case 'icon-optional':
            return 'layout';
        case 'icon-padding':
            return 'layout';
        case 'icon-pitch-alignment':
            return 'layout';
        case 'icon-rotate':
            return 'layout';
        case 'icon-rotation-alignment':
            return 'layout';
        case 'icon-size':
            return 'layout';
        case 'icon-text-fit':
            return 'layout';
        case 'icon-text-fit-padding':
            return 'layout';
        case 'icon-translate':
            return 'paint';
        case 'icon-translate-anchor':
            return 'paint';
        case 'line-blur':
            return 'paint';
        case 'line-cap':
            return 'layout';
        case 'line-color':
            return 'paint';
        case 'line-dasharray':
            return 'paint';
        case 'line-gap-width':
            return 'paint';
        case 'line-gradient':
            return 'paint';
        case 'line-join':
            return 'layout';
        case 'line-miter-limit':
            return 'layout';
        case 'line-offset':
            return 'paint';
        case 'line-opacity':
            return 'paint';
        case 'line-pattern':
            return 'paint';
        case 'line-round-limit':
            return 'layout';
        case 'line-sort-key':
            return 'layout';
        case 'line-translate':
            return 'paint';
        case 'line-translate-anchor':
            return 'paint';
        case 'line-width':
            return 'paint';
        case 'raster-brightness-max':
            return 'paint';
        case 'raster-brightness-min':
            return 'paint';
        case 'raster-contrast':
            return 'paint';
        case 'raster-fade-duration':
            return 'paint';
        case 'raster-hue-rotate':
            return 'paint';
        case 'raster-opacity':
            return 'paint';
        case 'raster-resampling':
            return 'paint';
        case 'raster-saturation':
            return 'paint';
        case 'symbol-avoid-edges':
            return 'layout';
        case 'symbol-placement':
            return 'layout';
        case 'symbol-sort-key':
            return 'layout';
        case 'symbol-spacing':
            return 'layout';
        case 'symbol-z-order':
            return 'layout';
        case 'text-allow-overlap':
            return 'layout';
        case 'text-anchor':
            return 'layout';
        case 'text-color':
            return 'paint';
        case 'text-field':
            return 'layout';
        case 'text-font':
            return 'layout';
        case 'text-halo-blur':
            return 'paint';
        case 'text-halo-color':
            return 'paint';
        case 'text-halo-width':
            return 'paint';
        case 'text-ignore-placement':
            return 'layout';
        case 'text-justify':
            return 'layout';
        case 'text-keep-upright':
            return 'layout';
        case 'text-letter-spacing':
            return 'layout';
        case 'text-line-height':
            return 'layout';
        case 'text-max-angle':
            return 'layout';
        case 'text-max-width':
            return 'layout';
        case 'text-offset':
            return 'layout';
        case 'text-opacity':
            return 'paint';
        case 'text-optional':
            return 'layout';
        case 'text-padding':
            return 'layout';
        case 'text-pitch-alignment':
            return 'layout';
        case 'text-radial-offset':
            return 'layout';
        case 'text-rotate':
            return 'layout';
        case 'text-rotation-alignment':
            return 'layout';
        case 'text-size':
            return 'layout';
        case 'text-transform':
            return 'layout';
        case 'text-translate':
            return 'paint';
        case 'text-translate-anchor':
            return 'paint';
        case 'text-variable-anchor':
            return 'layout';
        case 'visibility':
            return 'layout';
        default:
            return 'paint';
    }
};

const warnIfMissingNothingSelected = (nothingSelectedExpr, layer, path) => {
    if (!nothingSelectedExpr) {
        console.warn(`Layer "${layer.id}" has no expression for features when nothing is selected for path [${path}]`);
        return '';
    }

    return nothingSelectedExpr;
};

const warnIfMissingSelected = (selectedExpr, layer, path) => {
    if (!selectedExpr) {
        console.warn(`Layer "${layer.id}" has no expression for features that are selected for path [${path}]`);
        return '';
    }

    return selectedExpr;
};

const warnIfMissingNotSelected = (notSelectedExpr, layer, path) => {
    if (!notSelectedExpr) {
        console.warn(`Layer "${layer.id}" has no expression for features that are not selected for path [${path}]`);
        return '';
    }

    return notSelectedExpr;
};

/*
 * Build a Mapbox 'case' Expression from the input
 * A 'case' expression selects the first output in which the test condition evaluates to true
 * The last expression is the default fallback
 *
 * The three conditions created are:
 *     1. When nothing is selected,                                            use the nothing selected expression
 *     2. When a feature is selected,                                          use the selected expression
 *     3. (default expr) When a feature is not selected but something else is, use the not selected expression
 *
 * MapboxExpr === (String || Array)
 * @sig selection Expr :: (MapboxExpr, MapboxExpr, MapboxExpr, Layer) -> MapboxExpr
 */
const selectionExpr = (nothingSelectedExpr, selectedExpr, notSelectedExpr, layer, path) => {
    const nothingSelectedLabel = ['match', 'this "id" will not match any entity', 'selectedIds', true, false];
    const selectedLabel = desatIsSelected(true, false);

    nothingSelectedExpr = warnIfMissingNothingSelected(nothingSelectedExpr, layer, path);
    selectedExpr = warnIfMissingSelected(selectedExpr, layer, path);
    notSelectedExpr = warnIfMissingNotSelected(notSelectedExpr, layer, path);

    return [
        'case',
        nothingSelectedLabel,
        nothingSelectedExpr, // nothing selected expression
        selectedLabel,
        selectedExpr, // selected expression
        notSelectedExpr, // default not selected expressoin
    ];
};

const desatIsSelected = (selected, notSelected = '') => ['match', ['get', 'id'], 'selectedIds', selected, notSelected];

/*
 * Remove (or reset to defaults) fields of the style to generic values
 */
const removeExtraneousStyleFields = (style, venueId, venueCategory, accountId) => {
    // Mapbox Studio probably output, say, Johnny's personal value for these
    style = R.mergeRight(style, {
        sprite: `https://content.locuslabs.com/${venueCategory}/spritesheet-mapbox/${venueId}/${accountId}/spritesheet`,
        glyphs: `https://content.locuslabs.com/${venueCategory}/font/${venueId}/${accountId}/{fontstack}/{range}.pbf`,
    });

    // Since this style will be applied to many different maps, the values for these fields
    // output by Mapbox Studio will be incorrect
    style = R.omit(['bearing', 'name', 'owner', 'pitch', 'sources', 'visibility', 'zoom'], style);

    return style;
};

/*
 * Fix the value of the layer's "source" field to be either "ordinalSource" or "backgroundSource"
 * depending on the name of the layer's "source-layer" field, and then get rid of the source-layer field entirely:
 *
 *     "source": "composite",
 *     "source-layer": "dynamicgso-terminal-2-aki1d1",   => "source": "ordinalSource"
 *
 *     "source": "composite",
 *     "source-layer": "dynamicgso-7yu2yx",              => "source": "backgroundSource"
 */
const replaceLayerSource = layer => {
    const substituteSourceLayer = () => {
        const name = R.propOr('', 'source-layer', layer);

        if (R.match(/map *notes/i, name).length) return 'mapNotes';
        if (R.match(/.*-.*-.*/, name).length) return 'ordinalSource';
        if (R.match(/.*-.*/, name).length) return 'landscape-background';

        if (layer.id !== 'background') {
            const s = `style.json: layer '${layer.id}' has a source-layer ("${name}") that will never show any features`;
            console.error(s);
        }

        return 'composite';
    };

    const substituteCompositeSourceName = () => {
        const name = R.propOr('', 'source-layer', layer);

        if (R.match(/road_label/, name).length) return 'road';
        if (R.match(/((state|country)_label)/, name).length) return 'place_label';

        return name;
    };

    /*
     * Substitute the layer path with a 'case' expression that has three conditions (see selectionExpr)
     * The metadata field will consist of the 'selection' object with keys representing the field that is being modified
     * Each field being modified should have a "selected" and "notSelected" expression, and the field being modified
     * should by default contain the "nothingSelected" expression when there is nothing in the array of selectedIds
     * Metadata field example:
     *     "metadata": {
     *          "selection": {
     *              "text-color": { "selected": "#c60c30", "notSelected": "#4d4563" },
     *              "icon-image": { "selected": "wayfinding.end" },
     *              "text-field": { "selected": ["get", "text"] }
     *          }
     *      },
     * This will replace the layer.paint.text-color path with a generated 'case' expression
     * using the selected and notSelected Mapbox Expressions
     * 'selected' and 'notSelected' can be a String || Array which is equal to a Mapbox Expression
     *
     * @sig substituteMedadata :: () -> Layer
     */
    const substituteMetadata = () => {
        const selection = R.pathOr(null, ['metadata', 'selection'], layer);

        if (!selection) return layer;

        const substituteDesat = (value, key) => {
            const path = [keyToLayerStyle(key), key];
            const expr = selectionExpr(R.path(path, layer), value.selected, value.notSelected, layer, path);
            layer = R.assocPath(path, expr, layer);
        };

        R.mapObjIndexed(substituteDesat, selection);
        return layer;
    };

    /*
     * This function modify '==' operation expression inside of an all statement
     * e.g:
     * before:
     * "filter": [
     *      "all",
     *      ["==", ["geometry-type"], "Polygon"],
     *      [...],
     *      ...
     *  ]
     * after:
     * "filter": [
     *      "all",
     *      ["==", "geometry-type", "Polygon"],
     *      [...],
     *      ...
     *  ]
     *
     * @sig editFilterWithEqualOperationInsideAllStatement :: () -> Layer
     */
    const editFilterWithEqualOperationInsideAllStatement = () => {
        const filterField = layer.filter;
        const oldPolygonExpression = ['==', ['geometry-type'], 'Polygon'];
        if (filterField && R.startsWith(['all', oldPolygonExpression], filterField)) {
            const filterUpdated = R.update(1, R.flatten(oldPolygonExpression), filterField);
            layer = R.assocPath(['filter'], filterUpdated, layer);
        }
        return layer;
    };

    /*
     * This function modify 'in' operation expression inside of an all statement
     * e.g:
     * before:
     * "filter": [
     *      "all",
     *      [...],
     *      ["in", "section.building", [ "get", "category" ]],
     *  ]
     * after:
     * "filter": [
     *      "all",
     *      [...],
     *      ["in", "section.building", "get", "category"],
     *  ]
     *
     * @sig editFilterInExtression :: () -> Layer
     */
    const editFilterInExpression = () => {
        const filterField = layer.filter;
        const oldExpression = ['in', 'section.building', ['get', 'category']];
        if (filterField && R.endsWith([oldExpression], filterField)) {
            const index = filterField.length - 1;
            const filterUpdated = R.update(index, R.flatten(oldExpression), filterField);
            layer = R.assocPath(['filter'], filterUpdated, layer);
        }
        return layer;
    };

    layer = R.assoc('source', substituteSourceLayer(), layer);
    layer =
        layer.source === 'composite'
            ? R.assoc('source-layer', substituteCompositeSourceName(), layer)
            : R.dissoc('source-layer', layer);
    layer = substituteMetadata();
    layer = editFilterWithEqualOperationInsideAllStatement();
    layer = editFilterInExpression();

    return layer;
};

/*
 * Fix each layer
 */
const fixLayers = style => R.map(replaceLayerSource, style.layers);

/*
 * Convert the JSON object we've been manipulating up to now into a JavaScript function of the form:
 *
 *     const defaultMapStyle = (backgroundSource, ordinalSource, selectedIds) => ({
 *         <style>
 *     })
 *
 *     export default defaultMapStyle`
 *
 * In addition, previously we put marker text as values into our JSON in order to keep it valid JSON,
 * but now we need to convert the markers to JavaScript expressions:
 *
 *      "source": "ordinalSource" =>
 *      "source":  ordinalSource
 */
const convertJsonToJavaScriptFunction = style => {
    let outputText = JSON.stringify(style);

    outputText = R.replace(/"selectedIds"/g, 'selectedIds', outputText);
    outputText = R.replace(/"ordinalSource"/g, 'ordinalSource', outputText);
    return `(function(ordinalSource, selectedIds){return ${outputText}})`;
};

/*
 * Write a sorted mapping of each style.json layer id to its source for debugging
 * Impure: writes to console
 * @sig dumpLayerToSourceMap :: MapboxStyle -> ()
 */
const dumpLayerToSourceMap = style => {
    const layers = R.clone(style.layers);
    const mapIndex = R.addIndex(R.map);
    const layersWithOriginalLayerOrder = mapIndex((l, layerNumber) => {
        l.layerNumber = layerNumber;
        return l;
    }, layers);

    console.group('mapping of layers to sources');
    const table = F.textTable(layersWithOriginalLayerOrder, ['id', 'source', 'layerNumber']);
    R.forEach(console.log, table);
    console.groupEnd();
};

const evaluateStyle = (source, venueId, venueCategory, accountId) => {
    let style = JSON.parse(source);
    style = removeExtraneousStyleFields(style, venueId, venueCategory, accountId);
    style = R.assoc('layers', fixLayers(style), style);

    dumpLayerToSourceMap(style); // debugging

    const result = convertJsonToJavaScriptFunction(style);
    return eval(result);
};

const convertStyle = (source, venueCategory, venueId, accountId) => {
    const sourceJSON = JSON.stringify(source);

    return evaluateStyle(sourceJSON, venueId, venueCategory, accountId);
};

export { convertStyle };
